export const COMMON_RULE_PARAMS = {
    direction: 'ingress',
    ethertype: 'IPv4',
    ip: '0.0.0.0/0',
};

export const STANDARD_SECURITY_GROUP_NAMES = [
    'rdp+www',
    'rdp',
    'all',
    'ssh+www',
    'ssh',
];

export const DEFAULT_SECURITY_GROUP_NAMES = [
    ...STANDARD_SECURITY_GROUP_NAMES,
    'default',
];

export const SECURITY_GROUP_TO_RULES = {
    all: [{}],
    ssh: [
        {
            portRangeMin: 22,
            portRangeMax: 22,
            protocol: 'tcp',
        },
    ],
    rdp: [
        {
            portRangeMin: 3389,
            portRangeMax: 3389,
            protocol: 'tcp',
        },
    ],
    'rdp+www': [
        {
            portRangeMin: 3389,
            portRangeMax: 3389,
            protocol: 'tcp',
        },
        {
            portRangeMin: 80,
            portRangeMax: 80,
            protocol: 'tcp',
        },
        {
            portRangeMin: 443,
            portRangeMax: 443,
            protocol: 'tcp',
        },
    ],
    'ssh+www': [
        {
            portRangeMin: 22,
            portRangeMax: 22,
            protocol: 'tcp',
        },
        {
            portRangeMin: 80,
            portRangeMax: 80,
            protocol: 'tcp',
        },
        {
            portRangeMin: 443,
            portRangeMax: 443,
            protocol: 'tcp',
        },
    ],
};

export const FIREWALL_OPTIONS = [
    {
        value: 'ssh+www',
        text: 'Разрешен только ssh и www',
    },
    {
        value: 'ssh',
        text: 'Разрешен только ssh',
    },
    {
        value: 'all',
        text: 'Все разрешено',
    },
];

export const FIREWALL_OPTIONS_WINDOWS = [
    {
        value: 'rdp+www',
        text: 'Разрешен только rdp и www',
    },
    {
        value: 'rdp',
        text: 'Разрешен только rdp',
    },
    {
        value: 'all',
        text: 'Все разрешено',
    },
];
